export default {
    name: "",
    description: "",
    streamsourceIds: []
};